import RichTextEditor from '@ben/orion/rich-text-editor';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { fieldCannotBeBlankErrorMessage } from '../../../shared/constants';

interface IModularTextBlockInputProps {
  componentControllerName: string;
}

const ModularTextBlockInput = ({
  componentControllerName,
}: IModularTextBlockInputProps) => {
  const { control } = useFormContext();

  return (
    <Wrapper>
      <Controller
        control={control}
        name={`${componentControllerName}.description`}
        render={({ field, fieldState }) => (
          <RichTextEditor
            {...field}
            hasError={!!fieldState.error}
            errorMessage={fieldState.error?.message}
            name="Description"
            showName
            width="100%"
          />
        )}
        rules={{
          validate: (value) =>
            value?.length > 0 || fieldCannotBeBlankErrorMessage,
        }}
      />
    </Wrapper>
  );
};

export default ModularTextBlockInput;

const Wrapper = styled.div`
  width: 100%;
`;
